import * as React from 'react';

import * as classNames from "classnames";
import './GroupNotesPage.scss';

import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";

import ReactTable, { Column, RowInfo } from 'react-table';

import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';

import { RestrictedLayout } from "../../../components/layouts/index";

import * as GroupActions from '../../../actions/groups';
import * as ToggleActions from '../../../actions/pages/togglePage';
import * as ToggleHelper from "../../../helpers/toggleHelper";
import { TogglePageItem } from '../../../reducers/pages/togglePage';

import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { convertToShortDateString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { GroupSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface IGroupNotePageParams {
    groupId: number;
}

interface IGroupNotePageProps {

    location: Location;
    groupId: number;
    match: match<IGroupNotePageParams>;
    history: History;

    // From state
    group: Dtos.Group;

    loadingGroup: boolean;
    loadGroupSuccess: boolean;
    loadGroupFailure: boolean;

    user: Dtos.User,
    permissions?: Dtos.PersonnelTmdPermissions[];
    toggleItems: TogglePageItem[]
}

interface IGroupNotePageActions {
    clearGroup: GroupActions.IGroupClearActionCreator;
    loadGroup: GroupActions.IGroupLoadByIdActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;
}

type GroupNotePageProps = IGroupNotePageProps & IGroupNotePageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class GroupNotePage extends React.PureComponent<GroupNotePageProps, any> {

    constructor(props: GroupNotePageProps) {
        super(props);

        this.clearGroup = this.clearGroup.bind(this);
    }

    componentDidMount() {
        const {
            loadGroup,
            groupId
        } = this.props;

        loadGroup(groupId);
    }

    componentWillReceiveProps(nextProps: GroupNotePageProps) {
    }

    componentDidUpdate(prevProps: GroupNotePageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: GroupNotePageProps) {
    }

    componentWillUnmount() {
        this.clearGroup();
    }

    clearGroup() {
        this.props.clearGroup();
    }

    showGroup(): boolean {
        const {
            loadingGroup,
            loadGroupSuccess
        } = this.props

        if (!loadingGroup && loadGroupSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingGroup,
            permissions,
            group
        } = this.props;

        let id = group ? group.id : 0;
        let name = group ? group.name : "Group";

        return <RestrictedLayout
            permission={Dtos.Permission.GroupNotesView}
            subMenuItems={GroupSubMenu(id, permissions)}
            loading={loadingGroup}
        >
            {this.renderContent()}
        </RestrictedLayout>;
    }

    renderContent() {
        const {
            group,
            loadingGroup,
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-9 mb-2"}>
                    <h2>Group Notes</h2>
                </div>
                <div className="col-3" style={{ textAlign: 'right' }}>
                    {(AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupNotesCreate) && group && group.id > 0 ) && (
                        <Link className={"btn btn-primary"} url={"/groups/" + group.id + '/notes/create'}>Create</Link>
                    )}
                </div>
            </div>
            {
                loadingGroup ?
                    "Loading Notes" :
                    null
            }
            {
                !loadingGroup ?
                    <div className="mt-2">
                        {this.renderTable()}
                    </div> :
                    null
            }
        </div>
    }

    toggle(noteTypeNotes: Dtos.NoteTypeNotes) {

    }

    renderTable() {
        const {
            group,
            toggleItems,
            toggleExpand
        } = this.props;


        if (!group || !group.notes || group.notes.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no notes to view.</span>
            </div>
        }

        const showPagination = false; //personnelRoleSummaries.length > DEFAULT_PAGE_SIZE;

        return <div>
            {group && group.notes && group.notes.map((item, index) => {
                const key = "group-notes-page-" + item.noteTypeId;
                const expanded = ToggleHelper.isToggleExpanded(toggleItems, key);
                return (
                    <div key={"note-type" + index}>
                        <div className={tableHeaderClass} style={tableStyleClass} onClick={() => toggleExpand(key)}>
                            <div>
                                <FontAwesomeIcon icon={!expanded ? FontAwesomeIcons.Solid.ANGLE_DOWN : FontAwesomeIcons.Solid.ANGLE_UP} fixedWidth transform="grow-16" className="mr-3" />
                            </div>
                            <span>{item.noteType.value}</span>
                        </div>
                        {expanded && (
                            <ReactTable
                                data={item.notes}
                                pageSizeOptions={PAGE_SIZE_OPTIONS}
                                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : item.notes.length}
                                pageSize={showPagination ? undefined : item.notes.length}
                                showPagination={showPagination}
                                className="-striped -highlight -clickable mb-3"
                                noDataText="There are currently no notes for this type"
                                resizable={false}
                                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                                    return {
                                        onClick: (e, handleOriginal) => {
                                            console.log(rowInfo);
                                            const url: string = "/groups/" + group.id + '/notes/' + rowInfo.original.id;
                                            this.props.navigate(url);

                                            if (handleOriginal) {
                                                handleOriginal()
                                            }

                                        },
                                        style: {
                                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                                        }
                                    }
                                }}
                                columns={
                                    [
                                        {
                                            id: "id",
                                            Header: ' ',
                                            accessor: "id",
                                            className: "d-flex align-items-center justify-content-center",
                                            maxWidth: 50,
                                            Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.NOTE} fixedWidth />
                                        },
                                        {
                                            id: "title",
                                            Header: "Title",
                                            accessor: "title",
                                            className: "d-flex align-items-left justify-content-left",
                                            headerClassName: "text-left"
                                        },
                                        {
                                            id: "comments",
                                            Header: "Comments",
                                            accessor: "comments",
                                            className: "d-flex align-items-left justify-content-left",
                                            headerClassName: "text-left"
                                        },
                                        {
                                            id: "dateEntered",
                                            Header: "Date Entered",
                                            accessor: "dateEntered",
                                            className: "d-flex align-items-center justify-content-center",
                                            maxWidth: 180,
                                            Cell: (props) => <div><span data-tip={convertToApproximateDateString(props.value)}>{convertToShortDateString(props.value)}</span><ReactTooltip /></div>
                                        }
                                    ]
                                }
                            />
                        )}
                    </div>
                )
            }
            )}
        </div>
    }

}


const mapStateToProps = (state: ITmdState, ownProps: GroupNotePageProps): IGroupNotePageProps => {

    let group: Dtos.Group | undefined = !(state.groups.formData instanceof Array) ? state.groups.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        groupId: ownProps.match ? ownProps.match.params.groupId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        group: group!,

        loadingGroup: state.groups.loadState && state.groups.loadState.status == RequestState.Pending,
        loadGroupSuccess: state.groups.loadState && state.groups.loadState.status == RequestState.Success,
        loadGroupFailure: state.groups.loadState && state.groups.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        toggleItems: state.togglePage.items
    };
};

const mapDispatchToProps = (dispatch): IGroupNotePageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadGroup: bindActionCreators(GroupActions.LoadGroupById, dispatch),
        clearGroup: bindActionCreators(GroupActions.Clear, dispatch),

        toggleExpand: bindActionCreators(ToggleActions.ToggleExpanded, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(GroupNotePage);
